module.exports = __webpack_public_path__ + "img/2.bacc8014.png";